module.exports = __webpack_public_path__ + "static/media/wpback.a2e62ace.jpg";